// import { MySQL, sql } from '@codemirror/lang-sql';
// import CodeMirror from '@uiw/react-codemirror';
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import axios from 'axios';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { API3_HOST } from 'helpers/urlHelper';
import React, { useEffect, useState } from 'react';
import { Button, Card, Form, FormControl, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import SQLQueryResult from './SQLQueryResult';

/***
 * Page for viewing / editing a query. Includes executing the query and viewing the results
 */
export default function Query() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [query, setQuery] = useState([]);

  const [txtName, setTxtName] = useState('');

  const [sqlText, setSqlText] = useState('');
  const [sqlResultError, setSqlResultError] = useState('');
  const [sqlResultJson, setSqlResultJson] = useState([]);

  // Save the query to the database.
  // This is called when the user clicks the save button
  const saveQuery = () => {
    axios({
      method: 'PUT',
      url: `${API3_HOST}/dashboard/query/${id}`,
      data: { name: txtName, sql: sqlText }
    })
      .then(() => {
        loadData();
      })
      .catch(err => {
        console.log('did not load data');
        console.error('Failed to load layout', err.message);
      });
  };

  /* Execute the query in sql text buffer and update sqlResultJson */
  const executeQuery = () => {
    setSqlResultJson([]);
    axios({
      method: 'POST',
      url: `${API3_HOST}/dashboard/query/execute`,
      data: { sql: sqlText }
    })
      .then(result => {
        setSqlResultError('');
        setSqlResultJson(result.data);
      })
      .catch(err => {
        console.log('did not load data');
        console.error('Failed to load layout', err.message);
        if (err.response.data) {
          setSqlResultError('SQL Error: ' + err.response.data);
        } else {
          setSqlResultError('SQL Error: ' + err.message);
        }
      });
  };

  // Load the query from the database
  // This is called when the component is mounted
  const loadData = () => {
    axios({
      method: 'get',
      url: `${API3_HOST}/dashboard/query/${id}`
    })
      .then(result => {

        setQuery(result.data);
        setTxtName(result.data.name);
        if (result.data.sql) {
          setSqlText(result.data.sql);
        }

        setIsLoading(false);
        setHasUnsavedChanges(false);
      })
      .catch(err => {
        console.log('did not load data');
        console.error('Failed to load layout', err);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  const sqlTextChanged = text => {
    setSqlText(text);
    setHasUnsavedChanges(true);
  };

  // Show a loading spinner while the data is being loaded
  if (isLoading) {
    return (
      <div className="text-center">
        <Spinner variant="primary" animation="border" role="status"></Spinner>
      </div>
    );
  }

  return (
    <>
      <Card className="p-0">
        <FalconCardHeader
          title={`Editing Query '${query.name}'`}
          light
          titleTag="h3"
          endEl={
            <>
              {hasUnsavedChanges ? (
                <span className="pr-4 text-warning">
                  <i>You have unsaved changes&nbsp;&nbsp;</i>
                </span>
              ) : (
                <></>
              )}
              <Button size="sm" onClick={saveQuery}>
                Save Changes
              </Button>
            </>
          }
        />

        <Card.Body className="p-3">
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Name</Form.Label>
            <FormControl
              placeholder="Name"
              aria-label="Name"
              value={txtName}
              onChange={e => {
                setTxtName(e.target.value);
                setHasUnsavedChanges(true);
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Access</Form.Label>
            <Form.Select aria-label="">
              <option value="private">Private</option>
              <option value="public">Public</option>
            </Form.Select>
          </Form.Group>
        </Card.Body>
      </Card>

      <br></br>

      <Card className="p-0">
        <FalconCardHeader
          title="SQL"
          light
          titleTag="h6"
          endEl={
            <>
              {sqlResultError ? (
                <span className="pr-2 text-danger">
                  An error occured executing the query&nbsp;
                </span>
              ) : (
                <></>
              )}
              <Button size="sm" onClick={executeQuery}>
                Execute
              </Button>
            </>
          }
        />

        <Card.Body className="p-0" style={{ minHeight: '200px' }}>
          {sqlResultError ? (
            <i className="text-danger p-2">{sqlResultError}</i>
          ) : (
            <></>
          )}

          {/* CodeMirror editor for SQL text */}
          {/* <CodeMirror
            value={sqlText}
            height="200px"
            theme="dark"
            onChange={sqlTextChanged}
            extensions={[
              sql({
                dialect: MySQL
              })
            ]}
          /> */}
        </Card.Body>
      </Card>

      <br></br>

      {sqlResultJson && sqlResultJson.length > 0 ? (
        <SQLQueryResult result={sqlResultJson}></SQLQueryResult>
      ) : (
        <></>
      )}
    </>
  );
}
